import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "h20" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "title mc mt30" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "fs24 fw600 centered",
    style: {"color":"#696969"}
  }, "確認")
], -1)
const _hoisted_5 = {
  class: "centered",
  style: {"color":"#696969"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "fs14 fw600 mt10" }, "削除すると今後表示されなくなります。", -1)
const _hoisted_7 = {
  key: 0,
  class: "fs12 centered centering"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "mt20"
}
const _hoisted_11 = { class: "fw600" }
const _hoisted_12 = {
  key: 0,
  class: "w100 centering",
  style: {"bottom":"0"}
}
const _hoisted_13 = {
  class: "posAb w100 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_14 = {
  class: "fs14 whiteColor fw600",
  style: {"padding-top":"15px"}
}
const _hoisted_15 = {
  key: 1,
  class: "w100 centering",
  style: {"bottom":"0"}
}
const _hoisted_16 = {
  class: "posAb w50 centered",
  style: {"left":"0","bottom":"0"}
}
const _hoisted_17 = { class: "fs14 fw400" }
const _hoisted_18 = {
  class: "posAb w50 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_19 = {
  class: "fs14 whiteColor fw600",
  style: {"padding-top":"15px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "ModalDeleteFromAddressBook",
    "content-class": "rad10 with_white_bg shadowContent modalSmall noscroll ",
    onBeforeOpen: _ctx.openModal
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "pad15",
        style: _normalizeStyle(`width:400px;height:${_ctx.height || 220}px;`)
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
            width: "30",
            height: "30",
            class: "posAb pointer",
            style: {"right":"10px"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hideDeleteUserModal(false)))
          }, null, 8, _hoisted_2)
        ]),
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          (_ctx.user)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_UserIcon, {
                  member: _ctx.user,
                  width: 25,
                  canEdit: false,
                  updateSelf: false,
                  showTooltip: false,
                  class: "fl mr6"
                }, null, 8, ["member"]),
                _createElementVNode("div", null, [
                  _createTextVNode(_toDisplayString(_ctx.user.name), 1),
                  _hoisted_8,
                  (_ctx.user.company_name)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, "(" + _toDisplayString(_ctx.user.company_name) + ")", 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.clg)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createTextVNode(" 削除するアドレス帳グループ: "),
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.clg.name), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.hideCancelButton)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("section", {
                  class: "w100 redBg fs16 pointer centered",
                  style: {"line-height":"50px","height":"50px"},
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitDeleteFromAddressBook && _ctx.submitDeleteFromAddressBook(...args)))
                }, [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.okButtonName ? _ctx.okButtonName : `削除`), 1)
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("section", {
                  class: "llgreyBg dgrey fs16 pointer centered",
                  style: {"line-height":"50px","height":"50px"},
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickCancel && _ctx.clickCancel(...args)))
                }, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.cancelButtonName ? _ctx.cancelButtonName : `キャンセル`), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("section", {
                  class: "w100 redBg fs16 pointer centered",
                  style: {"line-height":"50px","height":"50px"},
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submitDeleteFromAddressBook && _ctx.submitDeleteFromAddressBook(...args)))
                }, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.okButtonName ? _ctx.okButtonName : `削除`), 1)
                ])
              ])
            ]))
      ], 4)
    ]),
    _: 1
  }, 8, ["onBeforeOpen"]))
}